
const navigationsdata = {
  navigatorIndex: 0
}

navigationsdata.selectIndex = function() {
  return this.navigatorIndex
}

navigationsdata.setIndex = function(index) {
  this.navigatorIndex = index
}
export default navigationsdata
